var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",class:{'is-error': _vm.danger}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }